import { UseCampaignPortalModalPayload } from '@modals/EditCampaignPortalModal/hooks/useCampaignPortalModal'

import PortalOption from './PortalOption'

interface PortalOptionsProps {
  campaignPortalModalPayload: UseCampaignPortalModalPayload,
}

const PortalOptions = (props: PortalOptionsProps) => {
  const { campaignPortalModalPayload } = props

  const {
    filteredPortalOptions,
  } = campaignPortalModalPayload

  return (
    <>
      {filteredPortalOptions.map(portalOption => (
        <PortalOption
          campaignPortalModalPayload={campaignPortalModalPayload}
          key={portalOption.id}
          portalOption={portalOption}
        />
      ))}
    </>
  )
}

export default PortalOptions
